import React from 'react';

export type ListGroupProps = {
	title: React.ReactNode;
	children?: React.ReactNode;
	/** класс обёртки группы */
	className?: string;
	/** класс заголовка группы */
	titleClassName?: string;
};

export const ListGroup: React.FC<ListGroupProps> = ({title, children}) => (
	<>
		{title}
		{children}
	</>
);
